import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Divider, Grid, Typography } from '@mui/material';
import { RadioListItem } from 'components/Input/Radio';
import { FnAxios, FnDialog, I18n } from 'utilities/utilities';
import { TextBoxItem } from 'components/Input/TextBox';
import { GetMenuPermission } from 'utilities/SystemFunction';
import { SelectItem } from 'components/Input/Select/SelectItem';
import SwitchFormItem from 'components/Input/Switch';
import { BtnBack, BtnSave } from 'components/Button/ButtonAll';
import { useLocation, useNavigate } from 'react-router';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import moment from 'moment';
const MaterialForm = () => {
    const location = useLocation();
    const searchParams = location.search;
    const sID = new URLSearchParams(searchParams).get('sID');
    const navigate = useNavigate();
    const onBack = () => navigate("/MaterialList");
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const [arrMaterialType, setMaterialType] = useState<any>([]);
    const [arrMaterialUnit, setMaterialUnit] = useState<any>([]);
    const [isMaterialTypeID, setisMaterialTypeID] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isEdit, setEdit] = useState(false);
    const [isActive, setisActive] = useState(true);
    const form = useForm({
        shouldFocusError: true,
        mode: "all"
    });

    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const getFormInitial = () => {
        AxiosFn.Get(`Material/GetFormInitial`, {}, (result) => {
            setMaterialType(result.lstMaterialType);
            setMaterialUnit(result.lstMaterialUnit);
        })
    }

    useEffect(() => {
        getFormInitial();
        GetMaterialEdit();
    }, []);

    const onSubmit = (e) => {
        let param = {
            sID: sID ? sID : "",
            nMaterialType: form.getValues("nMaterialType"),
            sMaterial: form.getValues("sMaterial"),
            sMaterialDesc: form.getValues("sMaterialDesc"),
            nUnit: form.getValues("nUnit"),
            isActive: form.getValues("isActive"),
            isBorrow: form.getValues("sBorrow") ? form.getValues("sBorrow") == "1" ? true : false : false,
            nInactive: form.getValues("dInactive") ? form.getValues("dInactive").valueOf() : 0,
        };
        DialogFn.Submit("คุณต้องการบันทึก ใช่หรือไม่", () => {
            DialogFn.BlockUI();
            AxiosFn.Post(`Material/SaveMaterial`, param, (result) => {
                DialogFn.UnBlockUI();
                DialogFn.Success(`บันทึกสำเร็จ`);
                DialogFn.CloseSubmit()
                navigate(`/MaterialList`);
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    const GetMaterialEdit = () => {
        let param = {
            sID: sID ? sID : ""
        };
        setLoading(true);
        AxiosFn.Post(`Material/GetMaterialEdit`, param, (result) => {
            console.log("result",result);
            if (sID) {
                form.setValue("nMaterialType", result.nMaterialType);
                form.setValue("sMaterial", result.sMaterial);
                form.setValue("sMaterialDesc", result.sMaterialDesc);
                form.setValue("nUnit", result.nUnit);
                form.setValue("isActive", result.isActive);
                form.setValue(`sBorrow`, result.nMaterialType == 3 ? result.isBorrow ? "1" : "2" : "");
                form.setValue("dInactive", result.nInactive ? moment(result.nInactive) : null);
                setisMaterialTypeID(result.nMaterialType == 3 );
                setLoading(false);
                setEdit(result.isEdit);
                setisActive(result.isActive);
            }
        }, (err) => {
            if (!err.response) {
                DialogFn.Warning(err.Message);
            }
        }
        );
    };


    return (
        <React.Fragment>
            <FormProvider {...form}>
                <Grid container spacing={2}>

                    <Grid item xs={12} md={12}>
                        <RadioListItem
                            id={"nMaterialType"}
                            name={"nMaterialType"}
                            required={true}
                            options={arrMaterialType}
                            disabled={!isPermission || isEdit}
                            onChange={(e) => {
                                let arrData = arrMaterialType.filter(f => f.value == e)
                                arrData.map((item) => {
                                    setisMaterialTypeID(item.isBorrow);
                                });
                            }}
                            label={`${I18n.SetText("Material.sMaterialtype")}`}
                        />
                    </Grid>

                    {isMaterialTypeID && (
                        <Grid item xs={12} md={12}>
                            <RadioListItem
                                id={"sBorrow"}
                                name={"sBorrow"}
                                required={isMaterialTypeID}
                                options={[
                                    { value: "1", label: "ใช่" },
                                    { value: "2", label: "ไม่ใช่" },
                                ]}
                                disabled={!isPermission}
                                label={`${I18n.SetText("Material.sBorrowed")}`}
                            />
                        </Grid>
                    )}
                    <Grid item xs={12} md={12}>
                        <TextBoxItem
                            required={true}
                            label={`${I18n.SetText("Material.sNameMaterial")}`}
                            id={'sMaterial'}
                            name={'sMaterial'}
                            maxLength={150}
                            type={'text'}
                            IsShowMessageError
                            disabled={!isPermission}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <TextBoxItem
                            required={true}
                            label={`${I18n.SetText("Material.sSize")}`}
                            id={'sMaterialDesc'}
                            name={'sMaterialDesc'}
                            maxLength={150}
                            type={'text'}
                            IsShowMessageError
                            disabled={!isPermission}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <SelectItem
                            id="nUnit"
                            name={"nUnit"}
                            label={`${I18n.SetText("Material.sUnit")}`}
                            placeholder={`${I18n.SetText("Material.sUnit")}`}
                            options={arrMaterialUnit}
                            required={true}
                            disabled={!isPermission || isEdit}
                        />
                    </Grid>

                    <Grid item xs={12} md={12}>
                        <Typography>
                            สถานะ
                            <span style={{ color: "red" }}> * </span>
                        </Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <SwitchFormItem
                            name={"isActive"}
                            checkText='ใช้งาน'
                            uncheckText='ไม่ใช้งาน'
                            width={130}
                            id={"isActive"}
                            disabled={!isPermission}
                            onChange={(e) => {
                                setisActive(e ? true : false);
                            }}

                        />
                    </Grid>
                    {!isActive &&
                        <Grid item container xs={12} md={3}>
                            <DatePickerItem
                                name={"dInactive"}
                                id={"dInactive"}
                                label={"วันที่เริ่มต้นหยุดใช้งาน"}
                                fullWidth
                                disabled={!isPermission}
                                minDate={moment()}
                            />
                        </Grid>
                    }
                </Grid>
                <Grid container justifyContent="flex-start" sx={{ mt: 5 }}>
                    <Grid item xs={6} md={6}>
                        <BtnBack id={"btnBack"} onClick={() => onBack()} />
                    </Grid>

                    <Grid container item xs={6} md={6} justifyContent="flex-end">
                        <BtnSave
                            IsDisabled={!isPermission}
                            id={"btnSave"}
                            onClick={form.handleSubmit(
                                (e) => onSubmit(e),
                                (err) => console.log("err", err)
                            )}
                        />
                    </Grid>
                </Grid>
            </FormProvider>
        </React.Fragment >
    );
}
export default MaterialForm;

export interface Borrow {
    isBorrow?: boolean;

}